module.exports = {
  GOLD_UPGRADE: 'GoldIntro'
  GOLD_RECOMMENDATION: 'GoldEarned'
}



// WEBPACK FOOTER //
// ./app/scripts/data/gold-banners.coffee